import {
  getAddressTokenRequest,
  getAddressTokenFailure,
  getAddressTokenSuccess,
} from '@actions/addressApi';

import { addressApiToken } from '@common/endpoints';

export const fetchAddressApiToken = () => (dispatch, _, request) => {
  dispatch(getAddressTokenRequest());

  return request
    .get(addressApiToken())
    .then(({ data }) => {
      dispatch(getAddressTokenSuccess(data));
    })
    .catch(error => {
      dispatch(getAddressTokenFailure(error));
    });
};
